import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-pdo-submission-list" }

import { onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { mineBreadcurmbStore } from '@/stores';
  import Record from '@/components/offline-collection/record.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();

  onMounted(async () => {
    mineBreadcurmbStore.update([
      { name: t('PDO Dashboard'), to: { name: 'pdo.programs' } },
      { name: String(route.query.title), to: { name: 'pdo.program', params: { id: route.params.id } } },
      { name: t('offline_collection.oc_records') }
    ]);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Record, {
      type: "PDO",
      title: _unref(t)('offline_collection.oc_records')
    }, null, 8, ["title"])
  ]))
}
}

})